// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Y3Rt","list":"BalanceDue_list__1ZqNt","listRow":"BalanceDue_listRow__14CKf","total":"BalanceDue_total__3xl2a"};